/* Layout Designer -> Wellforces cart bridge.
   Receives the designer iframe's add-to-cart postMessage, performs a native
   /cart/add.js add for a logged-in trade customer, and replies to the iframe
   so the designer shows its OWN confirmation:
     lm:cart-added   — added; the designer shows "Added → View cart"
     lm:cart-denied  — not a trade customer; the designer prompts to log in
     lm:cart-error   — the add failed (status carried through)
   On success it also refreshes the header cart-count bubble in place (Section
   Rendering API, mirroring product-form.js) but does NOT open the cart drawer:
   the drawer slides in behind the full-screen designer where it can't be
   clicked, so the designer's own "View cart" (new tab) supersedes it. Non-trade
   visitors (data-can-order="0") are never added. */
(function (global) {
  'use strict';
  var DEFAULT_ORIGIN = 'https://app.mapmysign.com';

  function addToCart(items, deps, reply) {
    return deps
      .fetch(deps.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: 'cart-icon-bubble',
          sections_url: deps.sectionsUrl || '/',
        }),
      })
      .then(function (res) {
        if (!res || !res.ok) {
          var status = res && res.status ? res.status : 0;
          deps.onFail(status);
          reply('lm:cart-error', { status: status });
          return false;
        }
        // The add already succeeded; a missing/invalid JSON body only means we
        // skip the in-place count refresh, never that the add itself failed.
        var done = function (data) {
          deps.onOk(data || null);
          reply('lm:cart-added');
          return true;
        };
        return res.json
          ? res.json().then(done, function () { return done(null); })
          : done(null);
      })
      .catch(function () {
        deps.onFail(0);
        reply('lm:cart-error', { status: 0 });
        return false;
      });
  }

  function handleMessage(event, deps) {
    if (!event || event.origin !== deps.allowedOrigin) return false;
    var data = event.data;
    if (!data) return false;
    // The gated (Wellforces) designer asks us to route the TOP window to Shopify
    // login: accounts live in Shopify and the iframe can't drive that itself. On
    // return, the storefront's SSO handshake signs the customer into the designer.
    if (data.type === 'lm:shopify-login') {
      if (typeof deps.onShopifyLogin === 'function') deps.onShopifyLogin();
      return true;
    }
    if (data.type !== 'lm:add-to-cart') return false;
    if (!Array.isArray(data.items) || data.items.length === 0) return false;
    // reply back into the designer iframe that sent the message, scoped to its
    // origin. No-op if the frame is gone (navigated/closed).
    var reply = function (type, extra) {
      var src = event.source;
      if (!src || typeof src.postMessage !== 'function') return;
      var msg = { type: type };
      if (extra) {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) msg[k] = extra[k];
        }
      }
      try { src.postMessage(msg, event.origin); } catch (e) { /* frame gone */ }
    };
    if (!deps.canOrder) {
      deps.onDenied();
      reply('lm:cart-denied');
      return true;
    }
    addToCart(data.items, deps, reply);
    return true;
  }

  // Browser wiring — skipped under Node (globalThis has no addEventListener).
  if (global && typeof global.addEventListener === 'function' && !global.__lmBridgeInstalled) {
    global.__lmBridgeInstalled = true;
    var doc = global.document;
    var script = doc && doc.getElementById('lm-bridge');
    var allowedOrigin = (script && script.getAttribute('data-app-origin')) || DEFAULT_ORIGIN;
    var cartAddUrl = (script && script.getAttribute('data-cart-add-url')) || '/cart/add.js';
    var canOrder = !!(script && script.getAttribute('data-can-order') === '1');
    global.LayoutDesignerBridge = global.LayoutDesignerBridge || {};
    var deps = {
      allowedOrigin: allowedOrigin,
      cartAddUrl: cartAddUrl,
      canOrder: canOrder,
      sectionsUrl: (global.location && global.location.pathname) || '/',
      fetch: global.fetch.bind(global),
      onOk: function (data) {
        // Refresh the header cart-count bubble from the Section Rendering API
        // payload, exactly as product-form.js does; never open the drawer.
        try {
          var html = data && data.sections && data.sections['cart-icon-bubble'];
          var bubble = doc.getElementById('cart-icon-bubble');
          if (html && bubble) bubble.innerHTML = html;
        } catch (e) { /* count refresh is best-effort */ }
      },
      onFail: function (status) {
        if (typeof global.LayoutDesignerBridge.onFail === 'function') {
          global.LayoutDesignerBridge.onFail(status);
        }
      },
      onDenied: function () {
        if (typeof global.LayoutDesignerBridge.onDenied === 'function') {
          global.LayoutDesignerBridge.onDenied();
        }
      },
      onShopifyLogin: function () {
        // New customer accounts (Wellforces) authenticate on a separate hosted
        // domain and IGNORE the classic /account/login?return_url= — they need
        // /customer_authentication/login?return_to=<relative path> to come back
        // to this page (Shopify docs: storefronts/themes/sign-in). On return the
        // SSO handshake signs the customer into the designer.
        try {
          var loc = global.location;
          var here = (loc && (loc.pathname + loc.search)) || '/';
          loc.assign('/customer_authentication/login?return_to=' + encodeURIComponent(here));
        } catch (e) { /* navigation blocked; nothing else to do */ }
      },
    };
    global.addEventListener('message', function (e) { handleMessage(e, deps); });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { addToCart: addToCart, handleMessage: handleMessage };
  }
})(typeof window !== 'undefined' ? window : globalThis);
